import { Box } from "rebass/styled-components";
import { Label } from "@rebass/forms/styled-components";
import useTranslation from "next-translate/useTranslation";

import { ErrorProp } from ".";

interface Props {
  sx?: any;
  getCardNumberProps: any;
  [x: string]: any;
  onChange?: (value) => void;
  onBlur?: (value) => void;
}
const CardNumberInput = (props: Props) => {
  const { sx, getCardNumberProps, onChange, onBlur, ...rest } = props;

  const { t } = useTranslation("common");

  return (
    <Box sx={{ position: "relative" }}>
      <Label mb={1} htmlFor="frmCCNum">
        {t("cardNumber")}
      </Label>
      <Box
        {...getCardNumberProps({
          onChange: onChange,
          onBlur: onBlur
        })}
        as="input"
        sx={{
          bg: "samoyedWhite",
          border: "default",
          m: 0,
          py: 0,
          px: 2,
          pl: 2,
          pr: 2,
          height: "48px",
          lineHeight: "100%",
          fontSize: 2,
          borderRadius: "default",
          width: "100%",
          transition: "box-shadow 0.2s ease 0s",
          ":focus": {
            borderColor: "springGreen",
            outline: "none",
            boxShadow: "inputFocus",
            "~i": {
              opacity: 1
            }
          },
          ...sx
        }}
        {...rest}
      />
    </Box>
  );
};

CardNumberInput.defaultProps = {};
export default CardNumberInput;
